import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Widgets/spinner';
import { Button, Row } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Selection } from '../Common/selection';
import { Field } from 'redux-form';

const propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string.isRequired,
};

class ChoosePaymentMethodModal extends Component {
  constructor() {
    super();
    this.state = {
      inputText: '',
      errors: '',
    };
  }

  renderOptions() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.
    const options = [
      { value: true, label: 'Stripe' },
      { value: false, label: 'Anywhere' }
    ];
    return (
      <Field name="IsStripe" component={Selection} options={options} />
    );
  }

  render() {
    const { errors } = this.state;
    return (
      <div>
        <Row>
          <div className="text-center" style={{ marginTop: '20px' }}>
            <h3><Translate value="Choose Payment Method" /></h3>
          </div>
        </Row>
        <Row>
          { this.renderOptions() }
          <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}>
            <Button
              bsStyle="primary"
              onClick={() => { this.props.changePaymentMethod(this.props.IsStripe.value); }}
            >
              <em className="fa fa-check" /><Translate value="Confirm" />
            </Button>
          </div>
        </Row>
        <br />
        <Row>
          {errors !== '' && <div className="alert alert-danger"><Translate value={errors} /></div>}
        </Row>
      </div>
    );
  }
}

ChoosePaymentMethodModal.propTypes = propTypes;
export default ChoosePaymentMethodModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/ChoosePaymentMethodModal.jsx